<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <span class="marker" v-if="selectedDeparting">
          Departing
        </span>
        <span class="marker" v-if="selectedReturning">
          Returning
        </span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from "../store";
import Shared from "@/mixins/Shared";

export default {
  name: "SelectedFareMarkers",
  store: store,
  mixins: [Shared],
  props: ["fare"],
  computed: {
    selectedDeparting() {
      if (this.departFlight !== null) {
        return this.departFlight.label === this.fare;
      }
      return false;
    },
    selectedReturning() {
      if (this.returnFlight !== null) {
        return this.returnFlight.label === this.fare;
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_colours.scss";

.marker {
  display: inline-block;
  position: relative;
  top: -3px;
  background-color: $primary;
  color: white;
  border-radius: 3px;
  margin-right: 5px;
  padding-right: 3px;
  margin-left: -2px;
  padding: 2px;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: bold;
}
</style>
